import React from "react";
import Table from "sulu-admin-bundle/components/Table";
import { formatDate } from "./helpers/formatDate";
import styles from "./passport-statistics-page.module.scss";

const { Header, Body, Row, Cell, HeaderCell } = Table;

// Club view: statement + age group summary + passport list
const ClubView = ({ data, t }) => {
    const ageGroups = data.ageGroups || [];
    const passports = data.passports || [];
    const year = data.year;
    const total = data.totalPassports || 0;

    return (
        <div>
            <p className={styles.statement}>
                {t("dhb.passport_statistics.statement")
                    .replace("{date}", `01.01.${year}`)
                    .replace("{count}", String(total))}
            </p>
            <p className={styles.note}>{t("dhb.passport_statistics.note")}</p>

            {/* Age group summary table */}
            <div className={styles.tableWrapper}>
                <Table skin="dark">
                    <Header
                        allSelected={false}
                        selectInFirstCell={false}
                        skin="dark"
                    >
                        <HeaderCell>
                            {t("dhb.passport_statistics.column.age_group")}
                        </HeaderCell>
                        <HeaderCell>
                            {t("dhb.passport_statistics.column.birth_year")}
                        </HeaderCell>
                        <HeaderCell className={styles.numberCell}>
                            {t("dhb.passport_statistics.column.male")}
                        </HeaderCell>
                        <HeaderCell className={styles.numberCell}>
                            {t("dhb.passport_statistics.column.female")}
                        </HeaderCell>
                        <HeaderCell className={styles.numberCell}>
                            {t("dhb.passport_statistics.column.total")}
                        </HeaderCell>
                    </Header>
                    <Body selectInFirstCell={false}>
                        {ageGroups.map((ag) => {
                            const birthYearRange =
                                ag.birthYearFrom === 0
                                    ? t(
                                          "dhb.passport_statistics.and_older",
                                      ).replace(
                                          "{year}",
                                          String(ag.birthYearTo),
                                      )
                                    : `${ag.birthYearFrom} - ${ag.birthYearTo}`;

                            return (
                                <Row key={ag.label}>
                                    <Cell>{ag.label}</Cell>
                                    <Cell>{birthYearRange}</Cell>
                                    <Cell className={styles.numberCell}>
                                        {ag.male}
                                    </Cell>
                                    <Cell className={styles.numberCell}>
                                        {ag.female}
                                    </Cell>
                                    <Cell className={styles.totalCell}>
                                        {ag.total}
                                    </Cell>
                                </Row>
                            );
                        })}
                        <Row className={styles.totalRow}>
                            <Cell colSpan={2}>
                                <strong>
                                    {t("dhb.passport_statistics.totals")}
                                </strong>
                            </Cell>
                            <Cell className={styles.numberCell}>
                                <strong>
                                    {ageGroups.reduce(
                                        (s, ag) => s + ag.male,
                                        0,
                                    )}
                                </strong>
                            </Cell>
                            <Cell className={styles.numberCell}>
                                <strong>
                                    {ageGroups.reduce(
                                        (s, ag) => s + ag.female,
                                        0,
                                    )}
                                </strong>
                            </Cell>
                            <Cell className={styles.totalCell}>{total}</Cell>
                        </Row>
                    </Body>
                </Table>
            </div>

            {/* Individual passport list */}
            <div className={styles.sectionTitle}>
                {t("dhb.passport_statistics.passport_list")}
            </div>
            <div className={styles.tableWrapper}>
                <Table skin="dark">
                    <Header
                        allSelected={false}
                        selectInFirstCell={false}
                        skin="dark"
                    >
                        <HeaderCell>
                            {t("dhb.passport_statistics.column.last_name")}
                        </HeaderCell>
                        <HeaderCell>
                            {t("dhb.passport_statistics.column.first_name")}
                        </HeaderCell>
                        <HeaderCell>
                            {t("dhb.passport_statistics.column.birth_year")}
                        </HeaderCell>
                        <HeaderCell>
                            {t("dhb.passport_statistics.column.gender")}
                        </HeaderCell>
                        <HeaderCell>
                            {t(
                                "dhb.passport_statistics.column.passport_number",
                            )}
                        </HeaderCell>
                        <HeaderCell>
                            {t("dhb.passport_statistics.column.passport_type")}
                        </HeaderCell>
                        <HeaderCell>
                            {t("dhb.passport_statistics.column.valid_from")}
                        </HeaderCell>
                        <HeaderCell>
                            {t("dhb.passport_statistics.column.valid_to")}
                        </HeaderCell>
                        <HeaderCell>
                            {t("dhb.passport_statistics.column.issued_at")}
                        </HeaderCell>
                    </Header>
                    <Body selectInFirstCell={false}>
                        {passports.map((passport, i) => (
                            <Row key={i}>
                                <Cell>{passport.lastName}</Cell>
                                <Cell>{passport.firstName}</Cell>
                                <Cell>{passport.birthYear}</Cell>
                                <Cell>{passport.gender}</Cell>
                                <Cell>{passport.passportNumber}</Cell>
                                <Cell>{passport.passportType}</Cell>
                                <Cell>{formatDate(passport.validFrom)}</Cell>
                                <Cell>{formatDate(passport.validTo)}</Cell>
                                <Cell>{formatDate(passport.issuedAt)}</Cell>
                            </Row>
                        ))}
                    </Body>
                </Table>
            </div>
        </div>
    );
};

export default ClubView;
